import { GithubIcon } from "./Icon";

const Footer = () => {
  return (
    <footer>
      <div
        className="footer-top"
        style={{
          background: `url('/img/footer-bg.png') no-repeat center center / cover`,
        }}
      >
        <div className="container">
          <div className="count" data-aos="fade-up">
            1,100+
          </div>
          <div className="subtext" data-aos="fade-up">
            Servers powered by Carbon
          </div>

          <a
            href="https://github.com/CarbonCommunity/Carbon/releases/tag/production_build"
            target="_blank"
            rel="noreferrer"
            className="btn-base"
            data-aos="fade-up"
          >
            <span>Get Carbon</span>
            <GithubIcon />
          </a>
          <ul className="footer-menu" data-aos="fade-up">
            <li>
              <a href="#feature">Features</a>
            </li>
            <li>
              <a href="#discord">Discord</a>
            </li>
            <li>
              <a href="#documentation">Documentation</a>
            </li>
            <li>
              <a href="#plugins">Plugins</a>
            </li>
            <li>
              <a href="#faq">FAQ</a>
            </li>
            <li>
              <a href="#reviews">Reviews</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          All trademarks referenced are the properties of their respective
          owners. &copy; 2025 carbonmod.gg and codefling.com All rights
          reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
